import { apiTypes } from 'ui/api'

export const providersRequiringLocation: apiTypes.ApiProviderName[] = [
	'Fedex',
	'Speedee',
	'Purolator',
	'Canada_Post',
]
